import { Component, Input } from '@angular/core';
import { DisplayManagerService } from '@com-delta-idp/mnx-skymiles-shared';
import { Benefits } from '../../models/benefits.interfaces';

@Component({
  selector: 'idp-peak-bar',
  templateUrl: './peak-bar.component.html',
  styleUrls: ['./peak-bar.component.scss']
})
export class PeakBarComponent {
  @Input() content: Benefits = {} as Benefits;
  @Input() index = 0;

  constructor(public displayManagerService: DisplayManagerService) {}

  updateIndex() {
    this.displayManagerService.index$.next(
      `${+this.displayManagerService.index$.value + 1}`
    );
  }
}
